import { ValidatorFn, Validators } from "@angular/forms"
export class CustomValidators {
  static alpha: ValidatorFn = Validators.pattern('[a-zA-Z]*%content%');
  static alphaAllowSpaces: ValidatorFn = Validators.pattern('[a-zA-Z ]*%content%');
  static alphaAllowSpacesAndSplash: ValidatorFn = Validators.pattern('[a-zA-Z /]*%content%');
  static alphaNumeric: ValidatorFn = Validators.pattern('[a-zA-Z0-9]*%content%');
  static alphaNumericAllowSpaces: ValidatorFn = Validators.pattern('[a-zA-Z0-9 ]*%content%');
  static alphaNumericAllowDash: ValidatorFn = Validators.pattern('[a-zA-Z0-9-]*%content%');
  static numericAllowDash: ValidatorFn = Validators.pattern('[0-9-]*%content%');
  static numeric: ValidatorFn = Validators.pattern('[0-9]*%content%');
  static currency: ValidatorFn = Validators.pattern('[0-9,]*%content%');
  static addressLine: ValidatorFn = Validators.pattern('(([0-9]{1,}).(.*[a-zA-Z#/&]){2,}$)|(([RRHC]{2,}).[0-9]{1,})|(([0-9]{1,}).(.*[a-zA-Z#/&]){2,}.(.*[0-9#])$)');
  static date: ValidatorFn = Validators.pattern('((0|1)d{1})((0|1|2|3)d{1})((19|20)d{2})');
}
